import ApiService from '../api.service';

const BudgetManagementResource = {
  index: (params) => ApiService.get(`/v1/business/${params.business_id}/budget_managements`),
  validateOffer: (params) => ApiService.post(`/v1/business/${params.business_id}/budget_managements/${params.budget_management_id}/validate_offer`, params),
};

export default BudgetManagementResource;
